import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App error caught by ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-brand-bone flex items-center justify-center px-4" data-testid="error-boundary">
          <div className="max-w-md w-full rounded-2xl border border-border bg-white p-8 text-center shadow-sm">
            <h1 className="font-heading text-2xl font-bold text-brand-ink">Something went wrong</h1>
            <p className="mt-3 text-brand-ink/70">
              We hit an unexpected error. Please refresh the page — if it keeps happening,
              email frankmarina@3eleakfinder.com.
            </p>
            <button
              onClick={() => (window.location.href = "/")}
              className="mt-6 rounded-full bg-brand-green hover:bg-brand-greenDark text-white px-8 py-3 font-medium transition-colors"
              data-testid="error-boundary-home"
            >
              Back to home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
